var map = {
	"./s0.png": "a1bc",
	"./s1.png": "8cbf",
	"./s101.png": "0af6",
	"./s2.png": "37f3",
	"./s3.png": "36d3",
	"./s4.png": "ee51",
	"./s5.png": "8f80",
	"./s6.png": "e84f",
	"./s61.png": "6dc6",
	"./s7.png": "8175",
	"./s8.png": "a140",
	"./s9.png": "fc71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "746a";